import React, { Component } from 'react';
import Sticky from 'Components/Sticky';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { ReactComponent as BackIcon } from 'Icons/back.svg';
import { ReactComponent as DeleteIcon } from 'Icons/delete.svg';
import { ReactComponent as EditIcon } from 'Icons/edit.svg';
import { ReactComponent as CancelIcon} from 'Icons/cancel.svg';
import { ReactComponent as SaveIcon } from 'Icons/save.svg';
import { getUser } from 'Utils/storage';
import Input from 'Components/Input';
import Upload from 'Components/Upload';
import {
    GET_ROUTE_MASTER_DETAILS,
    UPDATE_ROUTE_MASTER_DETAILS,
    DELETE_ROUTE_MASTER_DETAILS,
    UPLOAD_ROUTE_MASTER_DETAILS,
    DOWNLOAD_ROUTE_MASTER_TEMPLATE,
    DOWNLOAD_ROUTE_MASTER_DETAILS,
    ADD_ROUTE_MASTER_DETAILS
} from 'Constants/actionConstants';
import ActionLoader from 'Components/ActionLoader/index';

class RouteMaster extends Component {
    constructor() {
        super();
        this.state = {
            search: '',
            offset: 0,
            rousterMasterDetails: [],
            routeId: null
        }
    }

    componentDidMount() {
        this.getRouteMaster();
    }

    getRouteMaster = () => {
        const { dispatch } = this.props;
        const { offset, search } = this.state;
        const user = getUser();
        const params = {
            offset,
            limit: 20,
            companyId: user.companyId
        }
        if(search) {
            params.search = search
        }
        dispatch({
            type: GET_ROUTE_MASTER_DETAILS,
            params,
            onSuccess: (data) => {
                this.setState({
                    rousterMasterDetails: data
                })
            }
        })
    }

    downloadRecord = () => {
        const { dispatch } = this.props;
        dispatch({
            type: DOWNLOAD_ROUTE_MASTER_DETAILS,
            params: {
                companyId: getUser().companyId
            },
            onSuccess: this.getRouteMaster
        })
    }

    downloadTemplate = () => {
        const { dispatch } = this.props;
        dispatch({
            type: DOWNLOAD_ROUTE_MASTER_TEMPLATE,
            params: {
                companyId: getUser().companyId
            },
            onSuccess: this.getRouteMaster
        })
    }

    onChangeInput = (index, event) => {
        const { rousterMasterDetails } = this.state;
        const { name, value } = event.target;
        rousterMasterDetails[index][name] = value;
        this.setState({ rousterMasterDetails });
    };

    editRouteMaster = (id) => {
        const { rousterMasterDetails } = this.state;
        this.setState({
            routeId: this.state.routeId === id ? null : id
        });
     }

    deleteRoute = (id) => {
        const { dispatch } = this.props;
        const user = getUser();
        const data = {
            company_id: user.companyId,
            route_id: id
        }
        dispatch({
            type: DELETE_ROUTE_MASTER_DETAILS,
            data,
            onSuccess: (data) => {
                this.getRouteMaster();
            } 
        })
    }

    cancelAction = (id, index) => {
        if(id){
          this.setState({
            routeId: null,
            }) 
        } else {
          const { rousterMasterDetails } = this.state;
          rousterMasterDetails.splice(index,1);
          this.setState({
            rousterMasterDetails
          })
        }
    }

    addRoute = () => {
        const { rousterMasterDetails } = this.state;
        const routeDetails = {
            from_city: '',
            from_state: '',
            from_country: '',
            company_id: getUser().companyId
        }
        this.setState({ rousterMasterDetails : [routeDetails, ...rousterMasterDetails]})
    }

    saveRoute = (data) => {
        const { dispatch } = this.props;
        dispatch({
            type: data.route_id ? UPDATE_ROUTE_MASTER_DETAILS : ADD_ROUTE_MASTER_DETAILS,
            data,
            onSuccess: () => {
                this.setState({ routeId: null })
                this.getRouteMaster();
            }
        })
    }

    uploadRecord = (file) => {
        const { dispatch } = this.props;
        dispatch({
            type: UPLOAD_ROUTE_MASTER_DETAILS,
            file,
            params: {
                companyId: getUser().companyId
            },
            onSuccess: this.getRouteMaster
        })
    }

    onSearch = (e) => {
        this.setState({
            search: e.target.value
        }, this.getRouteMaster);
    }

    previous = () =>{
		if(this.state.offset > 0){
			this.setState({
				offset : this.state.offset-10
			},this.getRouteMaster);
		}
	}
	next = () =>{
		this.setState({
			offset : this.state.offset+10
		},this.getRouteMaster);
    }

    render() {
        const { routeId, rousterMasterDetails, search } = this.state;
        return (
            <Sticky>
                {this.props.loader && <ActionLoader fixed={true} />}
                <div className="ph-20 pv-20">
                    <div className="pl-20 pr-20 pb-10">
                        <div>
                            <Link className="ht-30 flex flex-middle wt-max-content mb-10 mt-5" to={"/seeker"}>
                            <BackIcon className="mr-10 fill-theme curP fBold"/>Back</Link>
                        </div>

                        <div className="flex mt-20">
                            <div className="text-center fBold fs-24 mb-10 mr-20">Route Master</div>
                            <div className='mr-10'>
                                <input 
                                    placeholder={"Search"}
                                    type="text" 
                                    className=" col-1 br-20 ht-40 bg-gray search"
                                    name='search'
                                    value={search}
                                    onChange={this.onSearch}
                                />
                            </div>
                            <button
                                onClick={this.addRoute}
                                className={"ht-25 wt-150 br-20 theme-color border-theme fs-16 fBold pl-30 pr-30 mr-30 mt-10"}>
                                Add Record
                            </button>
                            <button className="ht-25 wt-200 br-20 theme-color border-theme fs-16 fBold pl-30 pr-30 mr-30 mt-10" onClick={this.downloadRecord}>Download Record</button>
                            <Upload onChange={this.uploadRecord} className="mt-10">
                                <button className="ht-25 wt-150 br-20 theme-color border-theme fs-16 fBold pl-30 pr-30 mr-30" >Upload</button>
                            </Upload>
                            <button className="ht-25 br-20 theme-color border-theme fs-16 fBold pl-30 pr-30 mr-30 mt-10" onClick={this.downloadTemplate}>Download Template</button>
                        </div>
                    </div>
                </div>
                <div className='mt-20 route-master'>
                    <table width="100%" border={1}>
                        <thead>
                            <tr>
                                <th>City</th>
                                <th>State</th>
                                <th>Country</th>
                                <th>Actions</th>
                            </tr>
                        </thead>
                        {(rousterMasterDetails || []).map((route, index) => {
                            const isReadOnly = (route.route_id && route.route_id !== routeId)
                        return(<tbody>
                            <tr key={index}>
                                <td>{isReadOnly ? route.from_city :
                                    <input
                                        name="from_city"
                                        placeholder="City"
                                        onChange={e => this.onChangeInput(index, e)}
                                        value={route.from_city || ''}
                                        className="pl-10 fs-16 border-light ht-40 col-1 br-5 mb-20 tCenter"
                                    />}
                                </td>
                                <td>{isReadOnly ? route.from_state :
                                    <input
                                        name="from_state"
                                        placeholder="State"
                                        onChange={e => this.onChangeInput(index, e)}
                                        value={route.from_state || ''}
                                        className="pl-10 fs-16 border-light ht-40 col-1 br-5 mb-20 tCenter"
                                    />
                                }</td>                                
                                <td>{isReadOnly ? route.from_country :
                                    <input
                                        name="from_country"
                                        placeholder="Country"
                                        onChange={e => this.onChangeInput(index, e)}
                                        value={route.from_country || ''}
                                        className="pl-10 fs-16 border-light ht-40 col-1 br-5 mb-20 tCenter"
                                    />
                                }</td>
                                <td>
                                {(route.route_id === routeId) || !route.route_id ? <>
                                    <CancelIcon className="wt-20 ht-20 ml-10 curP fBold" onClick={(e) => this.cancelAction(route.route_id, index)} />
                                    <SaveIcon className="wt-20 ht-20 ml-10 curP" onClick={() => this.saveRoute(route)} />
                                </> :
                                <>
                                    <EditIcon className="wt-20 ht-20 ml-10 curP fBold" onClick={() => this.editRouteMaster(route.route_id)} />
                                    <DeleteIcon className="wt-20 ht-20 ml-10 curP" onClick={() => this.deleteRoute(route.route_id)} /> 
                                 </>}
                                </td>
                            </tr>
                        </tbody>)})}
                    </table>
                </div>
                <div className='pv-10 ph-10 flex flex-between'>
                    <button className="ht-30 wt-150 br-20 theme-color border-theme fs-16 fBold pl-30 pr-30 mr-30 mt-10" onClick={this.previous}>Previous</button>
                    <button className="ht-30 wt-150 br-20 theme-color border-theme fs-16 fBold pl-30 pr-30 mr-30 mt-10" onClick={this.next}>Next</button>
                </div>
            </Sticky>
        );
    }
}

const mapStateToProps = ({ contracting }) => {
    return {
        loader: contracting.loader
    }
}

export default connect(mapStateToProps)(RouteMaster);